import { createSelector } from 'reselect'

import { requestSelector } from 'root-api'


export const customDomainSelector = createSelector(
  requestSelector,
  (state) => state.custom_domain || {}
)
